import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRomania = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffda44",
			d: "M345 16a255.5 255.5 0 0 0-178 0l-22.3 240L167 496a255.4 255.4 0 0 0 178 0l22.3-240z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M512 256A256 256 0 0 0 345 16v480c97.5-36 167-130 167-240z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M0 256a256 256 0 0 0 167 240V16A256 256 0 0 0 0 256z"
		})
	]
});
export default SvgRomania;
